import { atom, useAtom, useSetAtom } from "jotai";

export const liveFiltersAtom = atom<number[]>([]);

const useLiveFilters = () => {
  return useAtom(liveFiltersAtom);
};

export const useSetLiveFilters = () => useSetAtom(liveFiltersAtom);

export default useLiveFilters;
